<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableRelationalDatabaseServiceWarningDate"
      style="width: 100.1%;"
    >
      <template slot-scope="{ row, index }" slot="delete">
        <Button
          type="success"
          size="small"
          v-hasPermission="['monitor:relationalDatabaseServiceMonitor:log']"
          @click="rowClick(row)"
          >{{ $t("alarms.common.operationLog") }}</Button
        >
        <Button
          type="warning"
          size="small"
          v-hasPermission="[
            'monitor:relationalDatabaseServiceMonitor:alert_rule_edit'
          ]"
          @click="addOrUpdateHandle(row.id)"
          >{{ $t("alarms.common.edit") }}</Button
        >
        <Button
          type="info"
          size="small"
          @click="setSopHandle(row.id)"
          >{{ $t("alarms.common.setSop") }}</Button
        >
        <span @click="doDelete(index)">
          <Button
            type="error"
            size="small"
            v-hasPermission="[
              'monitor:relationalDatabaseServiceMonitor:alert_rule_delete'
            ]"
            @click="RDSWarningModal = true"
            >{{ $t("alarms.common.delete") }}</Button
          >
        </span>
      </template>
    </Table>
    <!-- 操作日志详情 -->
    <alert-rule-operation-log
      v-if="alertRuleOperationLogVisible"
      ref="alertRuleOperationLog"
    ></alert-rule-operation-log>
    <!-- 删除数据库模式框 -->
    <Modal v-model="RDSWarningModal" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align:center">
        <p>
          {{ $t("alarms.common.sureDelete") }} {{ alertRuleName }}
          {{ $t("alarms.common.what") }}?
        </p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="modal_loading"
          @click="removeRDSWarning()"
          :disabled="isDisable"
          >{{ $t("alarms.common.delete") }}</Button
        >
      </div>
    </Modal>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
    <!-- 弹窗，新增/编辑 -->
    <add-or-update-relational-database-service-warning
      v-if="addOrUpdateVisible"
      ref="addOrUpdate"
    ></add-or-update-relational-database-service-warning>
    <!-- 配置告警规则SOP弹窗 -->
    <alert-rule-sop-modal ref="alertRuleSopModal" @saved="getRDSWarningData"></alert-rule-sop-modal>
  </div>
</template>
<script>
import AlertRuleOperationLog from "../common/AlertRuleOperationLog.vue";
import { setCookie, getCookie } from "../../../utils/cookieUtil.js";
import TableRelationalDatabaseService from "../rds/TableRelationalDatabaseService.vue";
import AddOrUpdateRelationalDatabaseServiceWarning from "../rds/AddOrUpdateRelationalDatabaseServiceWarning";
import AlertRuleSopModal from "../common/AlertRuleSopModal.vue";

const tableRelationalDatabaseService = TableRelationalDatabaseService;
let tableRDSWarningVue = {};
export default {
  name: "TableRelationalDatabaseServiceWarning",
  components: {
    AddOrUpdateRelationalDatabaseServiceWarning,
    AlertRuleOperationLog,
    AlertRuleSopModal
  },
  data() {
    return {
      alertRuleOperationLogVisible: false,
      addOrUpdateVisible: false,
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      RDSWarningModal: false,
      isDisable: false,
      modal_loading: false,
      val: "",
      alertRuleName: "",
      stateType: ["enabled", "disabled"],
      columns: [
        {
          title: this.$t("alarms.common.alertRuleName"),
          key: "alertRuleName"
        },
        {
          title: this.$t("alarms.common.status"),
          key: "state",
          render: (h, params) => {
            return h("div", [
              h(
                "i-switch",
                {
                  // 数据库0 enabled,1 disabled
                  props: {
                    type: "primary",
                    size: "large",
                    value: params.row.state == "enabled" // 控制开关的打开或关闭状态，官网文档属性是value
                  },
                  on: {
                    "on-change": () => {
                      this.switch(params.index);
                    }
                  }
                },
                [
                  h("span", {
                    slot: "open",
                    domProps: {
                      innerHTML: this.$t("alarms.common.enable")
                    }
                  }),
                  h("span", {
                    slot: "close",
                    domProps: {
                      innerHTML: this.$t("alarms.common.disable")
                    }
                  })
                ]
              )
            ]);
          }
        },
        {
          title: this.$t("alarms.common.monitorIndex"),
          key: "monitorIndexName"
        },
        {
          title: this.$t("alarms.common.alertRule"),
          key: "alertRuleDesc"
        },
        {
          title: this.$t("alarms.common.contact"),
          key: "contactNameList"
        },
        {
          title: this.$t("alarms.common.scanType"),
          key: "scanTypeName"
        },
        {
          title: this.$t("alarms.common.aiIntervention"),
          key: "aiInterventionEnabled",
          width: 110,
          render: (h, params) => {
            const enabled = params.row.aiInterventionEnabled === 1 || params.row.aiInterventionEnabled === "1";
            return h("i-switch", {
              props: {
                value: enabled,
                size: "default"
              },
              on: {
                "on-change": (val) => {
                  this.changeAiIntervention(params.row.id, val ? 1 : 0, params.index);
                }
              }
            }, [
              h("span", { slot: "open", domProps: { innerHTML: this.$t("alarms.common.aiInterventionYes") } }),
              h("span", { slot: "close", domProps: { innerHTML: this.$t("alarms.common.aiInterventionNo") } })
            ]);
          }
        },
        {
          title: this.$t("alarms.common.sopType"),
          key: "sopType",
          width: 100,
          render: (h, params) => {
            const v = params.row.sopType;
            return h("div", v === 1 || v === "1"
              ? this.$t("alarms.common.sopTypeCustom")
              : this.$t("alarms.common.sopTypeDefault"));
          }
        },
        {
          title: this.$t("common.operation"),
          width: 260,
          slot: "delete"
        }
      ],
      tableRelationalDatabaseServiceWarningDate: []
    };
  },
  beforeCreate: function() {
    tableRDSWarningVue = this;
  },
  mounted: function() {
    tableRDSWarningVue.getRDSWarningData();
  },
  methods: {
    showAll: function() {
      tableRDSWarningVue.getRDSWarningData();
    },
    // 分页显示数据
    /****************************************************/
    getRDSWarningData: function() {
      eventBus.$on("alertRuleSearchName", function(val) {
        tableRDSWarningVue.alertRuleSearchName = val;
      });
      eventBus.$on("companyId", function(val) {
        tableRDSWarningVue.companyId = val;
      });
      eventBus.$on("accountId", function(val) {
        tableRDSWarningVue.accountId = val;
      });
      eventBus.$on("stateId", function(val) {
        tableRDSWarningVue.stateId = val;
      });
      eventBus.$on("typeId", function(val) {
        tableRDSWarningVue.typeId = val;
      });
      eventBus.$on("delayTypeId", function(val) {
        tableRDSWarningVue.delayTypeId = val;
      });
      eventBus.$on("databaseId", function(val) {
        tableRDSWarningVue.databaseId = val;
      });
      eventBus.$on("monitorIndex", function(val) {
        tableRDSWarningVue.monitorIndex = val;
      });
      eventBus.$on("aiInterventionEnabled", function(val) {
        tableRDSWarningVue.aiInterventionEnabled = val;
      });
      eventBus.$on("sopType", function(val) {
        tableRDSWarningVue.sopType = val;
      });
      const alertList = {
        alertRuleName: tableRDSWarningVue.alertRuleSearchName,
        companyId: tableRDSWarningVue.companyId,
        accountId: tableRDSWarningVue.accountId,
        stateId: tableRDSWarningVue.stateId,
        typeId: tableRDSWarningVue.typeId,
        delayTypeId: tableRDSWarningVue.delayTypeId,
        pageNum: this.current,
        pageSize: this.pageSize,
        monitorModule: 1,
        aiInterventionEnabled: tableRDSWarningVue.aiInterventionEnabled,
        sopType: tableRDSWarningVue.sopType,
        databaseId:
          this.$route.query.databaseId == null
            ? tableRDSWarningVue.databaseId
            : this.$route.query.databaseId,
        monitorIndex: tableRDSWarningVue.monitorIndex
      };
      //如果是Azure 并且 数据库引擎是 SQL Server monitorModule传19
      // if((this.$route.query.engine.indexOf("SQL Server") != -1)&&this.$route.query.accountTypeName=='Azure'){
      //     alertList.monitorModule=19;
      // }else if((this.$route.query.engine.indexOf("mysql") != -1)&&this.$route.query.accountTypeName=='Azure'){
      //     alertList.monitorModule=18;
      // }else{
      //     alertList.monitorModule=1;
      // }
      // alert(1);
      //账户列表分页
      this.$api.alertRule.pageAlertRule(alertList).then(res => {
        this.tableRelationalDatabaseServiceWarningDate = res.data.records;
        // 当前页
        this.current = res.data.current;
        // 总条数
        this.dataTotal = res.data.total;

        for (
          let i = 0;
          i < this.tableRelationalDatabaseServiceWarningDate.length;
          i++
        ) {
          // 状态
          this.tableRelationalDatabaseServiceWarningDate[
            i
          ].state = this.stateType[
            this.tableRelationalDatabaseServiceWarningDate[i].state
          ];
        }
      });
    },
    changePage: function(current) {
      this.current = current;
      tableRDSWarningVue.getRDSWarningData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableRDSWarningVue.getRDSWarningData();
    },
    // 销毁alertRuleSearchName
    beforeDestroy: function() {
      eventBus.$off("alertRuleSearchName");
    },
    // switch
    /****************************************************/
    switch(index) {
      this.index = index;
      // 打开是true,0启用 1禁用
      if (
        this.tableRelationalDatabaseServiceWarningDate[index].state == "enabled"
      ) {
        this.changeStatusMessage(
          this.tableRelationalDatabaseServiceWarningDate[index].id,
          "state",
          1
        );
      } else {
        this.changeStatusMessage(
          this.tableRelationalDatabaseServiceWarningDate[index].id,
          "state",
          0
        );
      }
    },
    // 更新反馈信息某一字段
    changeStatusMessage: function(id, key, value) {
      // 编辑状态
      this.$api.alertRule
        .changeStatus({
          id: id,
          state: value
        })
        .then(res => {
          tableRDSWarningVue.getRDSWarningData();
        });
    },
    // 删除
    /****************************************************/
    doDelete: function(index) {
      this.lineIndex = index;
      this.alertRuleName = this.tableRelationalDatabaseServiceWarningDate[
        index
      ].alertRuleName;
    },
    removeRDSWarning: function() {
      this.isDisable = true; //开始可以点击
      var lineIndex = this.lineIndex;
      //账户删除
      this.$api.alertRule
        .deleteAlertRule(
          "id",
          this.tableRelationalDatabaseServiceWarningDate[lineIndex].id
        )
        .then(res => {
          this.modal_loading = true;
          setTimeout(() => {
            // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
            //21条  3页  2*10+1时删除
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableRDSWarningVue.getRDSWarningData();
            tableRelationalDatabaseService.methods.showAll();
            this.isDisable = false;
            this.modal_loading = false;
            this.RDSWarningModal = false;
            this.$Message.success(this.$t("common.deleteSuccess"));
          }, 1000);
        });
    },
    // 编辑报警规则
    /**********************************************************************************/
    addOrUpdateHandle: function(id) {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id);
      });
    },
    // 设置SOP
    setSopHandle: function(id) {
      this.$refs.alertRuleSopModal.open(id);
    },
    // 切换AI接管状态
    changeAiIntervention: function(id, aiInterventionEnabled, index) {
      this.$api.alertRule
        .changeAiIntervention({ id: id, aiInterventionEnabled: aiInterventionEnabled })
        .then(res => {
          if (res.data && res.data.code !== undefined && res.data.code !== 200) {
            this.$Message.error(res.data.message);
            this.getRDSWarningData();
            return;
          }
          this.tableRelationalDatabaseServiceWarningDate[index].aiInterventionEnabled = aiInterventionEnabled;
          this.$Message.success(this.$t("configuration_management.customized_alarm_config.editSuccess"));
        })
        .catch(() => {
          this.getRDSWarningData();
        });
    },
    // 操作日志
    /****************************************************/
    rowClick: function(row) {
      this.alertRuleOperationLogVisible = true;
      this.$nextTick(function() {
        this.$refs.alertRuleOperationLog.getAlertRuleOperationLogData(row);
      });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/rds/TableRelationalDatabaseServiceWarning.vue